<style scope>
</style>

<template>
  <section class="container">
    <orcamento-piller-prospect-edit/>
  </section>
</template>

<script>
  import OrcamentoPillerProspectEdit from './piller/OrcamentoPillerProspectEdit'

  export default {
    components: {OrcamentoPillerProspectEdit},
    created () {
      if (!this.$store.state.parametros || !this.$store.state.parametros.id) {
        this.$air.sair()
        this.$root.$emit('acessar')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/orcamento/FormProspectEdit.vue